export default {"src":"/_next/static/media/tooth.927bd60a.svg","height":132,"width":91,"blurWidth":0,"blurHeight":0};